import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const EXPLORE = [
  { to: "/", label: "Home", testId: "footer-link-home" },
  { to: "/about", label: "About Us", testId: "footer-link-about" },
  { to: "/businesses", label: "Our Businesses", testId: "footer-link-businesses" },
  { to: "/approach", label: "Our Approach", testId: "footer-link-approach" },
  { to: "/contact", label: "Contact Us", testId: "footer-link-contact" },
];

const LEGAL = [
  { to: "/privacy-policy", label: "Privacy Policy", testId: "footer-link-privacy" },
  { to: "/terms", label: "Terms & Conditions", testId: "footer-link-terms" },
  { to: "/disclaimer", label: "Disclaimer", testId: "footer-link-disclaimer" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#02060F]">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="flex items-baseline gap-2 mb-5">
              <span className="font-display text-2xl tracking-tight text-white">
                Touson<span className="text-gold">.</span>
              </span>
              <span className="font-mono text-[10px] tracking-[0.35em] text-white/50">VENTURES</span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              Touson Ventures (OPC) Private Limited — a diversified Indian business company building
              practical, innovative and sustainable businesses.
            </p>
            <p className="mt-6 font-mono text-[11px] text-white/40" data-testid="footer-cin">
              CIN: U47912PN2026OPC254881
            </p>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-mono text-[11px] tracking-[0.3em] uppercase text-gold mb-6">Explore</h4>
            <ul className="space-y-3">
              {EXPLORE.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={l.testId}
                    className="text-sm text-white/60 hover:text-gold transition-colors duration-300"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-mono text-[11px] tracking-[0.3em] uppercase text-gold mb-6">Legal</h4>
            <ul className="space-y-3">
              {LEGAL.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={l.testId}
                    className="text-sm text-white/60 hover:text-gold transition-colors duration-300"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/admin"
                  data-testid="footer-link-admin"
                  className="text-sm text-white/30 hover:text-gold transition-colors duration-300"
                >
                  Admin
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4" data-testid="footer-registered-office">
            <h4 className="font-mono text-[11px] tracking-[0.3em] uppercase text-gold mb-6">Registered Office</h4>
            <address className="not-italic text-sm text-white/60 leading-relaxed">
              Touson Ventures (OPC) Private Limited
              <br />
              OFF.204, Sapphire Chambers,
              <br />
              S.No. 2/3/1 &amp; 2/3/2, Riviresa,
              <br />
              Baner Gaon, Pune, Haveli,
              <br />
              Maharashtra, India – 411045
            </address>
            <a
              href="mailto:support@touson.in"
              data-testid="footer-email-link"
              className="mt-5 inline-flex items-center gap-2 text-sm text-gold hover:text-gold-light transition-colors duration-300"
            >
              <Mail size={14} /> support@touson.in
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-4">
          <p className="text-xs text-white/40" data-testid="footer-copyright">
            © 2026 Touson Ventures (OPC) Private Limited. All Rights Reserved.
          </p>
          <p className="font-mono text-[11px] text-white/30 tracking-[0.2em]">TOUSON.IN</p>
        </div>
      </div>
    </footer>
  );
}
